import { combineReducers } from 'redux'
import common from './common';
import user from './user';
import art from './art';

export default combineReducers({
  common,
  user,
  art
})